import styled from '@emotion/styled';

export const Hidden = styled.div`
  display: none;
`

export const ListOptions = styled.div`
  padding-top: 20px;
  text-align: right;
`
